unit MaBelegEdit;

interface

uses
  System.SysUtils, System.Classes, System.StrUtils, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Storage,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Imaging.GIFImg, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls,
  XData.Web.Client, VCL.TMSFNCTypes, VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.WebCtrls, VCL.TMSFNCPageControl, VCL.TMSFNCTabSet,
  VCL.TMSFNCListBox, WEBLib.Lists, WEBLib.SignatureCapture, WebBasis, Data.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, WebBasis2, VCL.TMSFNCPanel, VCL.TMSFNCButton, Vcl.Mask,
  WEBLib.Mask;

[async] function DoMaBelegEdit( var aID_MaBeleg  : Integer ) : TModalResult; async;

type
  TfrmMaBelegEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbMaBelegCaption: TLabel;
    lbEntladung: TLabel;
    [async]
    pgContr: TTMSFNCPageControl;
    tabDaten: TTMSFNCPageControlContainer;
    mBeschreibung: TMemo;
    tabDoku: TTMSFNCPageControlContainer;
    ImgContr: TImageControl;
    lbDokumentPos: TLabel;
    fpFilePicker: TFilePicker;
    cbxBilder: TComboBox;
    btnBildDel: TTMSFNCToolBarButton;
    lbMaBelegID: TLabel;
    btnNavNext: TTMSFNCToolBarButton;
    btnNavPrev: TTMSFNCToolBarButton;
    lbMitarbeiter: TLabel;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    btnAkt: TTMSFNCToolBarButton;
    btnDownload: TTMSFNCToolBarButton;
    edtDatum: TDateTimePicker;
    WebLabel1: TLabel;
    WebLabel3: TLabel;
    lbStatus: TLabel;
    WebLabel4: TLabel;
    procedure fpFilePickerChange(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
     //
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure btnBildDelClick(Sender: TObject); async;
    [async] procedure fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string); async;
    [async] procedure Daten_Laden; async;
    [async] function  Daten_Speichern : Integer; async;
    [async] procedure Bilder_Laden; async;
    [async] procedure Bild_Anzeigen; async;
    [async] procedure Form_Uebersetzen; async;
    [async] procedure btnAktClick(Sender: TObject); async;
    [async] procedure btnPdfClick(Sender: TObject); async;
     //
    procedure DoDokumentNav(Sender: TObject);
    procedure pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
    procedure cbxBilderChange(Sender: TObject);
    procedure ImgContrDblClick(Sender: TObject);
    procedure btnOKClick(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);

  private
    iID_MaBeleg  : Integer;

    sAktBild : String;
    sDokTyp : String;
    sIDMandLand : String;
    function Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;


  public
    iID_Tau : Integer;
  protected procedure LoadDFMValues; override; end;

var frmMaBelegEdit: TfrmMaBelegEdit;

const cFormMaBelegEdit = 'MABELEGEDIT_';

implementation

{$R *.dfm}

uses UnitMain, Konstanten, GlobalWeb , SpediFucsDatenmodul, ShowGrafik ;


//================================================================================================//

function DoMaBelegEdit( var aID_MaBeleg  : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmMaBelegEdit := TfrmMaBelegEdit.Create(application);
  frmMaBelegEdit.Popup   := True;
  frmMaBelegEdit.iID_Sprache := frmMainForm.iID_Sprache;
  frmMaBelegEdit.iID_MaBeleg  := aID_MaBeleg;


  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmMaBelegEdit, frmMaBelegEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmMaBelegEdit.Resize;

  Try
    await( TModalResult, frmMaBelegEdit.Execute);  // excute form and wait for close

    Result := frmMaBelegEdit.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
        await( frmMaBelegEdit.Daten_Speichern );
        aID_MaBeleg := frmMaBelegEdit.iID_MaBeleg;
      End;
//
  Finally
    frmMaBelegEdit.Free;
  End;


  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Opt_Speichern;
begin

  TLocalStorage.SetValue( cFormMaBelegEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Opt_Laden;
begin
  pgContr.ActivePageIndex := StrToIntDef( TLocalStorage.GetValue( cFormMaBelegEdit+'PAGE' )  ,0);

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.btnOKClick(Sender: TObject);
begin
  inherited;

  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.btnPdfClick(Sender: TObject);
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sBildDatei : String;
    aObj : TParam;
    iID : Integer;
    am : TMemoryStream;
    mr : TModalResult;
begin
  inherited;

  If cbxBilder.ItemIndex = -1 then Exit;
  If cbxBilder.Items.Count = 0 then Exit;

  sBildDatei := cbxBilder.Text;

  If not WaitMessage.Showing then WaitMessage.Show;



  aObj := TParam.Create;
  aObj.String1 := c_MaBeleg;
  aObj.String2 := sBildDatei;
  aObj.Integer1  := self.iID_MaBeleg ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_Bild', [aObj] ));
  ClientConn.Free;

  aObj.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);

  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;

  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Bild konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      am := TMemoryStream.Create;
        TTMSFNCUtils.LoadStreamFromBase64( sDaten, am );
      am.SaveToFile(sBildDatei);
      am.Free;
    End;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Bilder_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sSQL, sTmp : String;
    aSL, aSL_Daten : TStringList;
    i, iAnz, iAnzDok  : Integer;
    aObj : TParam;
    aArray : TArray<string>;
begin


  If not WaitMessage.Showing then WaitMessage.Show;

  aObj := TParam.Create;
  aObj.String1 := c_MaBeleg;
  aObj.Integer1  := self.iID_MaBeleg ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.Get_Bilder', [ aObj ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aObj.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := sDaten;

  cbxBilder.Items.clear;

  For i := 0 to aSL_Daten.Count -1 Do
    Begin
       sTmp := aSL_Daten[i];
       cbxBilder.Items.Add( aSL_Daten[i] )
    End;

  iAnzDok := cbxBilder.Items.Count;
  cbxBilder.Enabled   := (iAnzDok>0);
  cbxBilder.Enabled := (iAnzDok>0);

  lbDokumentPos.Caption := '0/0';

  If iAnzDok > 0 then
    Begin
      cbxBilder.ItemIndex :=  (iAnzDok-1);
      lbDokumentPos.Caption := IntToStr( cbxBilder.ItemIndex+1 ) +'/' +IntToStr( cbxBilder.Items.Count );
    End;

  aSL.Free;
  aSL_Daten.Free;

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.btnAktClick(Sender: TObject);
begin
  await(  Bilder_Laden );
  await(  Bild_Anzeigen );
end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.btnBildDelClick(Sender: TObject);
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    Blob: JSValue;
    sImgBase64, sDaten, sBildDatei : String;
    iID, iErg : Integer;
    res: TModalResult;
    aObj : TParam;
begin


  If cbxBilder.ItemIndex = -1 then Exit;
  If cbxBilder.Items.Count = 0 then Exit;

  Res := await(TModalResult, MessageDlgAsync('Bild löschen ?', mtConfirmation, [mbYes, mbNo]));
  If Res <> mrYes then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  sBildDatei := cbxBilder.Text;

  aObj := TParam.Create;
  aObj.String1 := c_MaBeleg;
  aObj.String2 := sBildDatei;
  aObj.Integer1  := self.iID_MaBeleg ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
   Response := await( ClientConn.RawInvokeAsync('ISystemService.Del_Bild', [aObj] ));
  ClientConn.Free;

  aObj.Free;

  cbxBilder.Items.Delete(cbxBilder.ItemIndex);
  cbxBilder.ItemIndex :=  cbxBilder.Items.Count-1;

  ImgContr.Clear;

  await( Bild_Anzeigen );

  WaitMessage.Hide;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.cbxBilderChange(Sender: TObject);
begin
  inherited;
  Bild_Anzeigen;
end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sInfo, sKopfZeile: String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop : Integer;
    aGuiObj :  TCoreGuiObj;
    aArray : TArray<string>;
    li: TListItem;
begin

  console.log('TfrmMaBelegEdit.Daten_Laden - Start '+IntToStr(self.iID_MaBeleg) );

  If not WaitMessage.Showing then WaitMessage.Show;


  sSQL := '01:SELECT B.*, '
            +' (SELECT BEZEICHNUNG FROM STATUS ST WHERE ST.ID_STATUS=B.ID_STATUS) as STATUS_BEZ, '
            + ' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
            +'   FROM ADRESSE A, MITARBEITER M  '
            +'   WHERE A.ID_ADRESSE=M.ID_ADRESSE AND M.ID_MITARBEITER=B.ID_MITARBEITER ) as MAB '
            +' FROM MA_BELEG B WHERE B.ID_MA_BELEG='+IntToStr(self.iID_MaBeleg) +';'
        ;
  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  mBeschreibung.Clear;


  // Mitarbeiter-Beleg ---------------------------------------------------------
  //
  If self.iID_MaBeleg = 0 then
    Begin
      lbMaBelegCaption.Caption := 'Beleg anlegen...';
      edtDatum.DateTime := Date;
      lbMitarbeiter.Caption := frmMainForm.BenutzerMaZuname+', '+frmMainForm.BenutzerMaVorname;

      lbMaBelegID.Caption := '';
      lbStatus.Caption := '';

    End
  Else
    Begin
      lbMaBelegCaption.Caption := 'Beleg bearbeiten...';

      iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');

      sFelder := aSL[1];
      sDaten  := aSL[2];

      lbMaBelegID.Caption := 'Nr: '+ GetFeldWert( sFelder, sDaten, 'ID_MA_BELEG'  );

      edtDatum.Date := StrToDateTime(  GetFeldWert( sFelder, sDaten, 'DATUM' )  );

      lbMitarbeiter.Caption := GetFeldWert( sFelder, sDaten, 'MAB'  );
      lbStatus.Caption := GetFeldWert( sFelder, sDaten, 'STATUS_BEZ'  );

      sTmp := GetFeldWert( sFelder, sDaten, 'BESCHREIBUNG'  );
      mBeschreibung.Text := ReplaceStr( sTmp, '##', chr(13)+chr(10) );

      console.log(  GetFeldWert( sFelder, sDaten, 'BESCHREIBUNG') );

    End;


  // Bilder -----------------------------------------------------------------
  await( Bilder_Laden );
  If pgContr.ActivePageIndex = 1 then  await(  Bild_Anzeigen );


  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  console.log('TfrmMaBelegEdit.Daten_Laden - Ende '+IntToStr(self.iID_MaBeleg) );

end;

//================================================================================================//

function TfrmMaBelegEdit.Daten_Speichern : Integer;
var Response : TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sSQL : String;
    aObj : TParam;
    iErg : Integer;
begin


  If self.iID_MaBeleg=0 then
    Begin
      aObj := TParam.Create;
      aObj.ID_Mab := StrToIntDef( frmMainForm.BenutzerMaNr,0);
      aObj.Datum1 := Date;
      aObj.String1 := frmMainForm.User_Account;

      ClientConn := TXDataWebClient.Create(nil);
      ClientConn.Connection := frmMainForm.XDataConn;

      Response := await( ClientConn.RawInvokeAsync('ISystemService.MaBelegIns', [ aObj] ));

      iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

      self.iID_MaBeleg := iErg;

      ClientConn.Free;
      aObj.Free;

      console.log('angelegt...' +Inttostr(self.iID_MaBeleg)   );

    End;


  sSQL := 'UPDATE MA_BELEG SET '
        +' DATUM = '+cH+DateTimeToStr(edtDatum.DateTime)+cH  +', '
        +' BESCHREIBUNG = '+cH+Trim(mBeschreibung.Text)+cH
        +' WHERE ID_MA_BELEG='+IntToStr(self.iID_MaBeleg)
        +';' ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  sSQL := await( Crypt( sSQL ));

  Response := await( ClientConn.RawInvokeAsync('ISystemService.SetDatenPaket', [ sSQL ] ) );
  Blob := Response.Result;

  ClientConn.Free;

  console.log(sSQL + 'upgedatet...');

end;


//====================================================================================================================//

procedure TfrmMaBelegEdit.DoDokumentNav(Sender: TObject);
var iIdx, iAnz : Integer;
begin

  If cbxBilder.Items.Count=0 then Exit;

  iIdx := cbxBilder.ItemIndex;
  Inc(iIdx);
  iAnz := cbxBilder.Items.Count;

  If Sender = btnNavNext then
    Begin
      If iIdx = iAnz then Exit;
      cbxBilder.ItemIndex := cbxBilder.ItemIndex +1;
    End
  Else
    Begin
      If iIdx = 1 then Exit;
      cbxBilder.ItemIndex := cbxBilder.ItemIndex -1;
    End;

  Bild_Anzeigen;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.fpFilePickerChange(Sender: TObject);
begin
  fpFilePicker.Files[0].GetFileAsBase64;
end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.fpFilePickerGetFileAsBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
var sBase64, sBildDatei, sExt : String;
    aFile : TFile;
    Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    aObj : TParam;
begin


  If self.iID_MaBeleg=0 then  await( Daten_Speichern);


  aFile :=  fpFilePicker.Files[AFileIndex];
  sExt  := UpperCase( ExtractFileExt(aFile.Name) );

  console.log( sExt );

  If (sExt='.PNG') or (sExt='.JPG') or (sExt='.JPEG') or (sExt='.BMP')  then
    Begin
      sBase64 := c_ImgVorsatz + ABase64;
      ImgContr.url := sBase64;
    End;


  sBildDatei := aFile.Name;
  sBildDatei := 'B'+IntToStr(self.iID_MaBeleg)+'_'+FormatDateTime('yymmdd_hhnnss', Now)   + sExt ;

  console.log( sBildDatei );

  aObj := TParam.Create;
  aObj.String1 := c_MaBeleg;
  aObj.String2 := sBildDatei;
  aObj.String3 := aBase64;
  aObj.Integer1  := self.iID_MaBeleg ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Set_Bild', [ aObj ] ));
  ClientConn.Free;

  TFile(fpFilePicker.Files[AFileIndex]).Name := sBildDatei;

  await( Daten_Laden );

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Bild_Anzeigen;
var aGuiObj : TCoreGuiObj;
    ClientConn : TXDataWebClient;
    Response: TXDataClientResponse;
    aObj : TParam;
    Blob: JSValue;
    sImgBase64, sDaten, sExt : String;
    sBildDatei : String;
    mr : TModalResult;
begin

  If cbxBilder.Items.Count=0 then lbDokumentPos.Caption := '0/0';

  If cbxBilder.ItemIndex = -1 then Exit;
  If cbxBilder.Items.Count = 0 then Exit;

  sBildDatei := cbxBilder.Text;

  // Bild schon geladen ?
  If sBildDatei = sAktBild then Exit;

  // Grafik-Format ?
  sExt := UpperCase( ExtractFileExt( sBildDatei ) );
  If (sExt<>'.JPG') and (sExt<>'.JPEG') and (sExt<>'.PNG') and (sExt<>'.BMP') and (sExt<>'.GIF') then Exit;


  If not WaitMessage.Showing then WaitMessage.Show;

  aObj := TParam.Create;
  aObj.String1 := c_MaBeleg;
  aObj.String2 := sBildDatei;
  aObj.Integer1  := self.iID_MaBeleg ;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response := await( ClientConn.RawInvokeAsync('ISystemService.Get_Bild', [aObj] ));
  ClientConn.Free;

  aObj.Free;

  sDaten := JS.toString (TJSObject(Response.Result)['value']);

  //sDaten := await( Crypt( sDaten ) );

  WaitMessage.Hide;

  If Copy(sDaten,1,6)= 'FEHLER' then
    Begin
     mr := await(TModalResult, MessageDlgAsync('Das Bild konnte nicht geladen werden...', mtInformation, [mbOK]));
    End
  Else
    Begin
      sImgBase64 := c_ImgVorsatz + sDaten;
      ImgContr.URL := sImgBase64;
    End;

  sAktBild := sBildDatei;

  lbDokumentPos.Caption := IntToStr( cbxBilder.ItemIndex+1 ) +'/' +IntToStr( cbxBilder.Items.Count );

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.WebButton1Click(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );
end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Opt_Speichern;
  inherited;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.WebFormCreate(Sender: TObject);
begin
  inherited;
  Opt_Laden;
end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.WebFormResize(Sender: TObject);
begin

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;

  // Komponenten
   iZielBreite := Trunc( self.Width * 0.95 );
   If iZielBreite > 500 then iZielBreite := 500;

   cbxBilder.Width := iZielBreite - cbxBilder.Left;

   fpFilePicker.Width := iZielBreite - fpFilePicker.Left;
   lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

   Console.Log('>> Form_Anpassen');
   lbDokumentPos.Left := cbxBilder.Left + cbxBilder.Width - lbDokumentPos.Width;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.WebFormShow(Sender: TObject);
begin

  Inherited;

  WaitMessage.Show;

  self.sAktBild := '';

  Sprach_Daten_Laden('SCHADENEDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;


end;

//====================================================================================================================//

function TfrmMaBelegEdit.Get_SQL_Ladestellen( aID_Tau : Integer ) : String;
begin


//  Result := 'SELECT WERT FROM OPTIONEN';
//  exit;

  Result :=

  'SELECT T.DATUM, T.POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, T.INFO AS LADE_INFO, T.LADEGUT, '
  +' (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, T.ZEIT AS ZEIT_TXT,  '
  +'  '+cH+cH+' as ANSP_NAME, '  +'  '+cH+cH+' as ANSP_ZUNAME, '
  +'  '+cH+cH+' as ANSP_TEL, '+cH+cH + ' as ANSP_ANREDE '
  +' FROM TAU_ADR T, ADRESSE A WHERE T.ID_ADRESSE = A.ID_ADRESSE '
  +' AND T.ID_TAU ='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.BELADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )

  +' UNION '

  +' SELECT T.BELADUNG_AM AS DATUM,  0 AS POS, A.ADR_ART, A.NAME1, A.NAME2, A.NAME3, A.STRASSE, A.PLZ, A.ORT, '
  +'  BELADUNG_INFO AS LADE_INFO, BELADUNG_LADEGUT AS LADEGUT, '
  +'  (SELECT L.LANDNAME FROM LAND L WHERE A.ID_LAND=L.ID_LAND) AS LANDNAME, BELADUNG_ZEIT AS ZEIT_TXT, '
  +'  (SELECT ZUNAME || '+cH+', '+cH+' || VORNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_NAME, '
  +'  (SELECT ZUNAME FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_ZUNAME, '
  +'  (SELECT TELEFON FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) AS ANSP_TEL, '
  +' CASE (SELECT ANREDE FROM ANSP_PARTNER AP WHERE AP.ID_ANSP_PARTNER=T.BELADUNG_ID_ANSP ) '
  + ' WHEN 1 THEN '+cH+'Firma'+cH
  + ' WHEN 2 THEN '+cH+'Herr'+cH
  + ' WHEN 3 THEN '+cH+'Frau'+cH
  +'  ELSE '+cH+cH
  +' END as ANSP_ANREDE '
  +' FROM ADRESSE A, TAU T WHERE A.ID_ADRESSE=T.ENTLADUNG_ID_ADR AND T.ID_TAU='+IntToStr( aID_Tau )


  +' ORDER BY 1 '; // T.DATUM, T.POS ' ;


end;

procedure TfrmMaBelegEdit.ImgContrDblClick(Sender: TObject);
begin
  inherited;
  Show_Grafik( ImgContr.URL );


end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.pgContrChangePage(Sender: TObject; APreviousPageIndex, ACurrentPageIndex: Integer);
begin

  If aCurrentPageIndex = 1 then  Bild_Anzeigen;
  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmMaBelegEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmSchadenEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmSchadenEdit');

//  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbNummer.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;





 self.bUebersetzt := True;


end;


//====================================================================================================================//

procedure TfrmMaBelegEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbMaBelegCaption := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  lbMaBelegID := TLabel.Create(Self);
  lbMitarbeiter := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  pgContr := TTMSFNCPageControl.Create(Self);
  tabDaten := TTMSFNCPageControlContainer.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  lbStatus := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  mBeschreibung := TMemo.Create(Self);
  edtDatum := TDateTimePicker.Create(Self);
  tabDoku := TTMSFNCPageControlContainer.Create(Self);
  ImgContr := TImageControl.Create(Self);
  lbDokumentPos := TLabel.Create(Self);
  fpFilePicker := TFilePicker.Create(Self);
  cbxBilder := TComboBox.Create(Self);
  btnBildDel := TTMSFNCToolBarButton.Create(Self);
  btnNavNext := TTMSFNCToolBarButton.Create(Self);
  btnNavPrev := TTMSFNCToolBarButton.Create(Self);
  btnAkt := TTMSFNCToolBarButton.Create(Self);
  btnDownload := TTMSFNCToolBarButton.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbMaBelegCaption.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  lbMaBelegID.BeforeLoadDFMValues;
  lbMitarbeiter.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  pgContr.BeforeLoadDFMValues;
  tabDaten.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  lbStatus.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  mBeschreibung.BeforeLoadDFMValues;
  edtDatum.BeforeLoadDFMValues;
  tabDoku.BeforeLoadDFMValues;
  ImgContr.BeforeLoadDFMValues;
  lbDokumentPos.BeforeLoadDFMValues;
  fpFilePicker.BeforeLoadDFMValues;
  cbxBilder.BeforeLoadDFMValues;
  btnBildDel.BeforeLoadDFMValues;
  btnNavNext.BeforeLoadDFMValues;
  btnNavPrev.BeforeLoadDFMValues;
  btnAkt.BeforeLoadDFMValues;
  btnDownload.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 525;
    Height := 567;
    Color := 16776441;
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 525;
    WebPanel1.Height := 84;
    WebPanel1.Align := alTop;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 0;
    lbMaBelegCaption.SetParentComponent(WebPanel1);
    lbMaBelegCaption.Name := 'lbMaBelegCaption';
    lbMaBelegCaption.Left := 157;
    lbMaBelegCaption.Top := 5;
    lbMaBelegCaption.Width := 142;
    lbMaBelegCaption.Height := 18;
    lbMaBelegCaption.Caption := 'Mitarbeiter-Beleg';
    lbMaBelegCaption.Font.Charset := DEFAULT_CHARSET;
    lbMaBelegCaption.Font.Color := clBlack;
    lbMaBelegCaption.Font.Height := -15;
    lbMaBelegCaption.Font.Name := 'Verdana';
    lbMaBelegCaption.Font.Style := [fsBold];
    lbMaBelegCaption.HeightPercent := 100.000000000000000000;
    lbMaBelegCaption.ParentFont := False;
    lbMaBelegCaption.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 57;
    lbEntladung.Width := 71;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Mitarbeiter';
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.WidthPercent := 100.000000000000000000;
    lbMaBelegID.SetParentComponent(WebPanel1);
    lbMaBelegID.Name := 'lbMaBelegID';
    lbMaBelegID.Left := 157;
    lbMaBelegID.Top := 29;
    lbMaBelegID.Width := 41;
    lbMaBelegID.Height := 18;
    lbMaBelegID.Caption := 'Nr: 0';
    lbMaBelegID.Font.Charset := ANSI_CHARSET;
    lbMaBelegID.Font.Color := clWindowText;
    lbMaBelegID.Font.Height := -15;
    lbMaBelegID.Font.Name := 'Verdana';
    lbMaBelegID.Font.Style := [fsBold];
    lbMaBelegID.HeightPercent := 100.000000000000000000;
    lbMaBelegID.ParentFont := False;
    lbMaBelegID.WidthPercent := 100.000000000000000000;
    lbMitarbeiter.SetParentComponent(WebPanel1);
    lbMitarbeiter.Name := 'lbMitarbeiter';
    lbMitarbeiter.Left := 103;
    lbMitarbeiter.Top := 57;
    lbMitarbeiter.Width := 71;
    lbMitarbeiter.Height := 16;
    lbMitarbeiter.Caption := 'T0000000';
    lbMitarbeiter.Font.Charset := ANSI_CHARSET;
    lbMitarbeiter.Font.Color := clWindowText;
    lbMitarbeiter.Font.Height := -13;
    lbMitarbeiter.Font.Name := 'Verdana';
    lbMitarbeiter.Font.Style := [fsBold];
    lbMitarbeiter.HeightPercent := 100.000000000000000000;
    lbMitarbeiter.ParentFont := False;
    lbMitarbeiter.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 72;
    btnOK.Top := 5;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    pgContr.SetParentComponent(Self);
    pgContr.Name := 'pgContr';
    pgContr.Left := 0;
    pgContr.Top := 84;
    pgContr.Width := 525;
    pgContr.Height := 483;
    pgContr.Align := alClient;
    pgContr.ParentDoubleBuffered := False;
    pgContr.Color := clBtnFace;
    pgContr.DoubleBuffered := True;
    pgContr.TabOrder := 1;
    pgContr.ActivePageIndex := 1;
    pgContr.Fill.Kind := gfkNone;
    pgContr.Fill.Color := 16776441;
    pgContr.Stroke.Kind := gskNone;
    pgContr.TabAppearance.Font.Charset := ANSI_CHARSET;
    pgContr.TabAppearance.Font.Color := clWindowText;
    pgContr.TabAppearance.Font.Height := -13;
    pgContr.TabAppearance.Font.Name := 'Verdana';
    pgContr.TabAppearance.Font.Style := [];
    pgContr.TabAppearance.Fill.Color := clWhite;
    pgContr.TabAppearance.ActiveFill.Color := 16639703;
    pgContr.TabAppearance.DownFill.Color := 15776936;
    pgContr.TabAppearance.DownStroke.Color := 15702829;
    pgContr.TabAppearance.HoverFill.Color := 16380654;
    pgContr.TabAppearance.HoverStroke.Color := 15702829;
    pgContr.TabAppearance.TextSpacing := 0.000000000000000000;
    pgContr.TabAppearance.ActiveTextColor := 4539717;
    pgContr.TabAppearance.HoverTextColor := 8026746;
    pgContr.TabAppearance.DownTextColor := 4539717;
    pgContr.TabAppearance.ShowFocus := False;
    pgContr.TabAppearance.CloseStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseDownStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.CloseHoverStroke.Width := 2.000000000000000000;
    pgContr.TabAppearance.BadgeFont.Charset := DEFAULT_CHARSET;
    pgContr.TabAppearance.BadgeFont.Color := clDarkred;
    pgContr.TabAppearance.BadgeFont.Height := -11;
    pgContr.TabAppearance.BadgeFont.Name := 'Segoe UI';
    pgContr.TabAppearance.BadgeFont.Style := [fsBold];
    pgContr.ButtonAppearance.CloseIcon.LoadFromFile('MaBelegEdit.pgContr.ButtonAppearance.CloseIcon.svg');
    pgContr.ButtonAppearance.InsertIcon.LoadFromFile('MaBelegEdit.pgContr.ButtonAppearance.InsertIcon.svg');
    pgContr.ButtonAppearance.TabListIcon.LoadFromFile('MaBelegEdit.pgContr.ButtonAppearance.TabListIcon.svg');
    pgContr.ButtonAppearance.ScrollNextIcon.LoadFromFile('MaBelegEdit.pgContr.ButtonAppearance.ScrollNextIcon.svg');
    pgContr.ButtonAppearance.ScrollPreviousIcon.LoadFromFile('MaBelegEdit.pgContr.ButtonAppearance.ScrollPreviousIcon.svg');
    pgContr.Options.TabListButton := True;
    pgContr.TabSize.Mode := tsmFixedSize;
    pgContr.TabSize.Width := 120.000000000000000000;
    pgContr.TabSize.Height := 40.000000000000000000;
    pgContr.TabSize.Margins.Left := 8.000000000000000000;
    pgContr.TabSize.Margins.Top := 8.000000000000000000;
    pgContr.TabSize.Margins.Right := 8.000000000000000000;
    pgContr.TabSize.Margins.Bottom := 8.000000000000000000;
    pgContr.Pages.Clear;
    with pgContr.Pages.Add do
    begin
      Text := 'Daten';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    with pgContr.Pages.Add do
    begin
      Text := 'Bilder';
      Color := 16776441;
      UseDefaultAppearance := True;
    end;
    SetEvent(pgContr, Self, 'OnChangePage', 'pgContrChangePage');
    tabDaten.SetParentComponent(pgContr);
    tabDaten.Name := 'tabDaten';
    tabDaten.AlignWithMargins := True;
    tabDaten.Left := 0;
    tabDaten.Top := 47;
    tabDaten.Width := 525;
    tabDaten.Height := 436;
    tabDaten.Margins.Left := 0;
    tabDaten.Margins.Top := 47;
    tabDaten.Margins.Right := 0;
    tabDaten.Margins.Bottom := 0;
    tabDaten.Align := alClient;
    tabDaten.ParentDoubleBuffered := False;
    tabDaten.Color := 16776441;
    tabDaten.DoubleBuffered := True;
    tabDaten.TabStop := False;
    tabDaten.TabOrder := 1;
    tabDaten.Visible := False;
    tabDaten.Fill.Color := 16776441;
    tabDaten.PageIndex := 0;
    tabDaten.IsActive := False;
    WebLabel1.SetParentComponent(tabDaten);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 18;
    WebLabel1.Width := 42;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Datum';
    WebLabel1.Color := 16776441;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(tabDaten);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 58;
    WebLabel3.Width := 50;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Status:';
    WebLabel3.Color := 16776441;
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    lbStatus.SetParentComponent(tabDaten);
    lbStatus.Name := 'lbStatus';
    lbStatus.Left := 80;
    lbStatus.Top := 58;
    lbStatus.Width := 71;
    lbStatus.Height := 16;
    lbStatus.Caption := 'T0000000';
    lbStatus.Color := 16776441;
    lbStatus.Font.Charset := ANSI_CHARSET;
    lbStatus.Font.Color := clWindowText;
    lbStatus.Font.Height := -13;
    lbStatus.Font.Name := 'Verdana';
    lbStatus.Font.Style := [fsBold];
    lbStatus.HeightPercent := 100.000000000000000000;
    lbStatus.ParentFont := False;
    lbStatus.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(tabDaten);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 84;
    WebLabel4.Width := 87;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Beschreibung';
    WebLabel4.Color := 16776441;
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    mBeschreibung.SetParentComponent(tabDaten);
    mBeschreibung.Name := 'mBeschreibung';
    mBeschreibung.Left := 16;
    mBeschreibung.Top := 106;
    mBeschreibung.Width := 481;
    mBeschreibung.Height := 279;
    mBeschreibung.Anchors := [akLeft,akTop,akRight,akBottom];
    mBeschreibung.Font.Charset := ANSI_CHARSET;
    mBeschreibung.Font.Color := clWindowText;
    mBeschreibung.Font.Height := -13;
    mBeschreibung.Font.Name := 'Verdana';
    mBeschreibung.Font.Style := [];
    mBeschreibung.HeightPercent := 100.000000000000000000;
    mBeschreibung.ParentFont := False;
    mBeschreibung.SelLength := 0;
    mBeschreibung.SelStart := 0;
    mBeschreibung.WidthPercent := 100.000000000000000000;
    edtDatum.SetParentComponent(tabDaten);
    edtDatum.Name := 'edtDatum';
    edtDatum.Left := 74;
    edtDatum.Top := 12;
    edtDatum.Width := 135;
    edtDatum.Height := 28;
    edtDatum.Cursor := crHandPoint;
    edtDatum.BorderStyle := bsSingle;
    edtDatum.ChildOrder := 5;
    edtDatum.Color := 15329769;
    edtDatum.Date := 45767.262767685180000000;
    edtDatum.Role := '';
    edtDatum.ShowSeconds := False;
    edtDatum.Text := '';
    tabDoku.SetParentComponent(pgContr);
    tabDoku.Name := 'tabDoku';
    tabDoku.AlignWithMargins := True;
    tabDoku.Left := 0;
    tabDoku.Top := 47;
    tabDoku.Width := 525;
    tabDoku.Height := 436;
    tabDoku.Margins.Left := 0;
    tabDoku.Margins.Top := 47;
    tabDoku.Margins.Right := 0;
    tabDoku.Margins.Bottom := 0;
    tabDoku.Align := alClient;
    tabDoku.ParentDoubleBuffered := False;
    tabDoku.Color := 16776441;
    tabDoku.DoubleBuffered := True;
    tabDoku.TabStop := False;
    tabDoku.TabOrder := 0;
    tabDoku.Fill.Color := 16776441;
    tabDoku.PageIndex := 1;
    tabDoku.IsActive := True;
    ImgContr.SetParentComponent(tabDoku);
    ImgContr.Name := 'ImgContr';
    ImgContr.Left := 3;
    ImgContr.Top := 138;
    ImgContr.Width := 519;
    ImgContr.Height := 295;
    ImgContr.WidthStyle := ssAuto;
    ImgContr.HeightPercent := 100.000000000000000000;
    ImgContr.WidthPercent := 100.000000000000000000;
    ImgContr.Anchors := [akLeft,akTop,akRight,akBottom];
    ImgContr.ChildOrder := 1;
    SetEvent(ImgContr, Self, 'OnDblClick', 'ImgContrDblClick');
    lbDokumentPos.SetParentComponent(tabDoku);
    lbDokumentPos.Name := 'lbDokumentPos';
    lbDokumentPos.Left := 427;
    lbDokumentPos.Top := 35;
    lbDokumentPos.Width := 22;
    lbDokumentPos.Height := 16;
    lbDokumentPos.Caption := '0/0';
    lbDokumentPos.Color := 16776441;
    lbDokumentPos.HeightPercent := 100.000000000000000000;
    lbDokumentPos.WidthPercent := 100.000000000000000000;
    fpFilePicker.SetParentComponent(tabDoku);
    fpFilePicker.Name := 'fpFilePicker';
    fpFilePicker.Left := 14;
    fpFilePicker.Top := 96;
    fpFilePicker.Width := 497;
    fpFilePicker.Height := 36;
    fpFilePicker.Accept := 'image/*';
    fpFilePicker.ChildOrder := 1;
    SetEvent(fpFilePicker, Self, 'OnChange', 'fpFilePickerChange');
    SetEvent(fpFilePicker, Self, 'OnGetFileAsBase64', 'fpFilePickerGetFileAsBase64');
    cbxBilder.SetParentComponent(tabDoku);
    cbxBilder.Name := 'cbxBilder';
    cbxBilder.Left := 14;
    cbxBilder.Top := 57;
    cbxBilder.Width := 497;
    cbxBilder.Height := 24;
    cbxBilder.Cursor := crHandPoint;
    cbxBilder.HeightStyle := ssAuto;
    cbxBilder.HeightPercent := 100.000000000000000000;
    cbxBilder.WidthPercent := 100.000000000000000000;
    SetEvent(cbxBilder, Self, 'OnChange', 'cbxBilderChange');
    cbxBilder.ItemIndex := -1;
    btnBildDel.SetParentComponent(tabDoku);
    btnBildDel.Name := 'btnBildDel';
    btnBildDel.Left := 226;
    btnBildDel.Top := 7;
    btnBildDel.Width := 65;
    btnBildDel.Height := 44;
    btnBildDel.Cursor := crHandPoint;
    btnBildDel.ParentDoubleBuffered := False;
    btnBildDel.DoubleBuffered := True;
    btnBildDel.Font.Charset := ANSI_CHARSET;
    btnBildDel.Font.Color := clWindowText;
    btnBildDel.Font.Height := -13;
    btnBildDel.Font.Name := 'Verdana';
    btnBildDel.Font.Style := [];
    btnBildDel.ParentColor := True;
    btnBildDel.TabOrder := 2;
    SetEvent(btnBildDel, Self, 'OnClick', 'btnBildDelClick');
    btnBildDel.Text := '';
    btnBildDel.TextVisible := False;
    btnBildDel.Bitmaps.Clear;
    with btnBildDel.Bitmaps.Add do
    begin
      BitmapName := 'DEL';
    end;
    btnBildDel.BitmapVisible := True;
    btnBildDel.BitmapContainer := BitmapCont;
    btnBildDel.ControlIndex := 0;
    btnNavNext.SetParentComponent(tabDoku);
    btnNavNext.Name := 'btnNavNext';
    btnNavNext.Left := 81;
    btnNavNext.Top := 7;
    btnNavNext.Width := 65;
    btnNavNext.Height := 44;
    btnNavNext.Cursor := crHandPoint;
    btnNavNext.ParentDoubleBuffered := False;
    btnNavNext.DoubleBuffered := True;
    btnNavNext.Font.Charset := DEFAULT_CHARSET;
    btnNavNext.Font.Color := clWindowText;
    btnNavNext.Font.Height := -11;
    btnNavNext.Font.Name := 'Segoe UI';
    btnNavNext.Font.Style := [];
    btnNavNext.ParentColor := True;
    btnNavNext.TabOrder := 3;
    SetEvent(btnNavNext, Self, 'OnClick', 'DoDokumentNav');
    btnNavNext.Text := '';
    btnNavNext.Bitmaps.Clear;
    with btnNavNext.Bitmaps.Add do
    begin
      BitmapName := 'RECHTS';
    end;
    btnNavNext.BitmapVisible := True;
    btnNavNext.BitmapContainer := BitmapCont;
    btnNavNext.ControlIndex := 0;
    btnNavPrev.SetParentComponent(tabDoku);
    btnNavPrev.Name := 'btnNavPrev';
    btnNavPrev.Left := 14;
    btnNavPrev.Top := 7;
    btnNavPrev.Width := 65;
    btnNavPrev.Height := 44;
    btnNavPrev.Cursor := crHandPoint;
    btnNavPrev.ParentDoubleBuffered := False;
    btnNavPrev.DoubleBuffered := True;
    btnNavPrev.Font.Charset := DEFAULT_CHARSET;
    btnNavPrev.Font.Color := clWindowText;
    btnNavPrev.Font.Height := -11;
    btnNavPrev.Font.Name := 'Segoe UI';
    btnNavPrev.Font.Style := [];
    btnNavPrev.ParentColor := True;
    btnNavPrev.TabOrder := 4;
    SetEvent(btnNavPrev, Self, 'OnClick', 'DoDokumentNav');
    btnNavPrev.Text := '';
    btnNavPrev.Bitmaps.Clear;
    with btnNavPrev.Bitmaps.Add do
    begin
      BitmapName := 'LINKS';
    end;
    btnNavPrev.BitmapVisible := True;
    btnNavPrev.BitmapContainer := BitmapCont;
    btnNavPrev.ControlIndex := 0;
    btnAkt.SetParentComponent(tabDoku);
    btnAkt.Name := 'btnAkt';
    btnAkt.Left := 154;
    btnAkt.Top := 7;
    btnAkt.Width := 65;
    btnAkt.Height := 44;
    btnAkt.Cursor := crHandPoint;
    btnAkt.ParentDoubleBuffered := False;
    btnAkt.DoubleBuffered := True;
    btnAkt.Font.Charset := ANSI_CHARSET;
    btnAkt.Font.Color := clWindowText;
    btnAkt.Font.Height := -13;
    btnAkt.Font.Name := 'Verdana';
    btnAkt.Font.Style := [];
    btnAkt.ParentColor := True;
    btnAkt.TabOrder := 5;
    SetEvent(btnAkt, Self, 'OnClick', 'btnAktClick');
    btnAkt.Text := '';
    btnAkt.TextVisible := False;
    btnAkt.Bitmaps.Clear;
    with btnAkt.Bitmaps.Add do
    begin
      BitmapName := 'AKT';
    end;
    btnAkt.BitmapVisible := True;
    btnAkt.BitmapContainer := BitmapCont;
    btnAkt.ControlIndex := 0;
    btnDownload.SetParentComponent(tabDoku);
    btnDownload.Name := 'btnDownload';
    btnDownload.Left := 299;
    btnDownload.Top := 7;
    btnDownload.Width := 65;
    btnDownload.Height := 44;
    btnDownload.Cursor := crHandPoint;
    btnDownload.ParentDoubleBuffered := False;
    btnDownload.DoubleBuffered := True;
    btnDownload.Font.Charset := ANSI_CHARSET;
    btnDownload.Font.Color := clWindowText;
    btnDownload.Font.Height := -13;
    btnDownload.Font.Name := 'Verdana';
    btnDownload.Font.Style := [];
    btnDownload.ParentColor := True;
    btnDownload.TabOrder := 6;
    SetEvent(btnDownload, Self, 'OnClick', 'btnPdfClick');
    btnDownload.Text := '';
    btnDownload.TextVisible := False;
    btnDownload.Bitmaps.Clear;
    with btnDownload.Bitmaps.Add do
    begin
      BitmapName := 'DOWNLOAD';
    end;
    btnDownload.BitmapVisible := True;
    btnDownload.BitmapContainer := BitmapCont;
    btnDownload.ControlIndex := 0;
    tabSprachDaten.Left := 368;
    tabSprachDaten.Top := 16;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbMaBelegCaption.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    lbMaBelegID.AfterLoadDFMValues;
    lbMitarbeiter.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    pgContr.AfterLoadDFMValues;
    tabDaten.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    lbStatus.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    mBeschreibung.AfterLoadDFMValues;
    edtDatum.AfterLoadDFMValues;
    tabDoku.AfterLoadDFMValues;
    ImgContr.AfterLoadDFMValues;
    lbDokumentPos.AfterLoadDFMValues;
    fpFilePicker.AfterLoadDFMValues;
    cbxBilder.AfterLoadDFMValues;
    btnBildDel.AfterLoadDFMValues;
    btnNavNext.AfterLoadDFMValues;
    btnNavPrev.AfterLoadDFMValues;
    btnAkt.AfterLoadDFMValues;
    btnDownload.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
